<template>
  <div class="header-menu tw-h-16 lg:tw-h-16 md:tw-h-32">
    <!-- 添加模糊遮罩层 -->
    <transition name="backdrop-fade">
      <div
        v-if="showCollapse || openMenu || openSearch"
        class="backdrop-overlay"
        @click="closeAllMenus"
      ></div>
    </transition>

    <div class="top-menu">
      <div
        class="tw-w-full tw-hidden lg:tw-h-16 md:tw-h-32 tw-bg-white md:tw-flex tw-shadow-sm xl:tw-px-36 lg:tw-px-10 md:tw-px-10"
      >
        <div class="tw-h-16 tw-flex tw-flex-none tw-items-center">
          <a href="#" @click.prevent="handleLogoClick">
            <img class="tw-h-10" src="@/static/staimg/tiansheng.png" alt />
          </a>
        </div>
        <div
          class="tw-absolute lg:tw-static tw-left-0 tw-top-16 tw-pl-8 tw-flex tw-items-center tw-h-16 tw-flex-none tw-gap-5 lg:tw-gap-5 xl:tw-gap-8 tw-text-sm tw-cursor-pointer tw-text-textMain"
        >
          <span
            v-for="item in leftMenu"
            :key="item.id"
            :class="{ 'tw-text-primary': $route.path.startsWith(item.path) }"
            class="hover:tw-text-primary tw-h-full tw-flex tw-items-center"
            @mouseenter="handleMouseEnter(item.id)"
            @mouseleave="handleMouseLeave"
            @click="handleClickRoute(item.path, item.id)"
            >{{ item.name }}</span
          >
        </div>
        <div
          class="tw-flex tw-items-center tw-flex-1 tw-h-16 tw-justify-end xl:tw-gap-4 tw-gap-3"
        >
          <TopSearch @onSearch="getEnter" />
          <LanguageSwitcher />
          <span
            class="nav-action-icon-button tw-cursor-pointer tw-text-primary tw-text-sm tw-flex-none"
            @click="handleClickRoute('/contact')"
          >
            <img
              class="nav-action-icon"
              src="@/assets/home/nav-support.png"
              alt=""
            />
          </span>

          <div class="tw-flex tw-items-center tw-cursor-pointer tw-flex-none">
            <template v-if="userInfo && userInfo.id !== null">
              <UserInfo @outLogin="handleLoginOut"></UserInfo>

              <!-- <img
                :src="userInfo.avatar "
                style="
                  width: 34px;
                  height: 34px;
                  border-radius: 18px;
                  margin-right: 6px;
                "
                alt
                @click="handleClickAvatar"
              />
              <b-dropdown
                ref="dropdown"
                variant="primary"
                size="sm"
                :text="userInfo.name || 'user'"
              >
                <b-dropdown-item href="#" @click="handleLoginOut">{{
                  $t("退出登录")
                }}</b-dropdown-item>
              </b-dropdown> -->
            </template>
            <template v-else>
              <b-link
                class="user-login"
                @click="handleClickRoute('/login')"
                type="primary"
                size="sm"
              >
                {{ $t("登录") }}
              </b-link>
              <b-button
                class="user-register"
                pill
                variant="primary"
                @click="handleClickRoute('/register')"
                size="sm"
              >
                {{ $t("注册") }}
              </b-button>
            </template>
          </div>
        </div>
      </div>

      <!-- 移动端头部  -->
      <div
        class="mobile mobile-header tw-flex md:tw-hidden tw-bg-white tw-items-center tw-justify-between"
      >
        <a href="/" class="mobile-brand">
          <img class="mobile-logo" src="@/static/staimg/tiansheng.png" alt />
        </a>
        <div class="mobile-actions">
          <b-icon
            class="mobile-action-btn"
            icon="search"
            @click="handleClickSearch"
          ></b-icon>

          <b-icon
            class="mobile-action-btn mobile-contact-btn"
            icon="telephone-fill"
            @click="handleClickRoute('/contact')"
          ></b-icon>

          <div class="mobile-user-entry">
            <template v-if="userInfo && userInfo.id !== null">
              <img
                :src="userInfo.avatar"
                class="mobile-avatar"
                alt
                @click="$router.push('/controlCenter')"
              />
            </template>
            <template v-else>
              <b-link
                class="user-login"
                @click="handleClickRoute('/login')"
                type="primary"
                size="sm"
              >
                {{ $t("登录") }}
              </b-link>
              <b-button
                class="user-register"
                pill
                variant="primary"
                @click="handleClickRoute('/register')"
                size="sm"
              >
                {{ $t("注册") }}
              </b-button>
            </template>
          </div>

          <div
            class="menu-icon mobile-menu-btn tw-flex tw-flex-col tw-justify-between tw-cursor-pointer"
            :class="{ open: openMenu }"
            @click="handleClickMenu"
          >
            <span class="menu-line"></span>
            <span class="menu-line"></span>
            <span class="menu-line"></span>
          </div>
        </div>
      </div>

      <!-- 电脑端菜单  -->
      <div>
        <b-collapse v-model="showCollapse">
          <BaseLayout>
            <div
              class="bg-white w-100 dropdown-content"
              style="
                min-height: 200px;
                max-height: 80vh;
                overflow-y: auto;
                border-radius: 8px;
                z-index: 10;
              "
              @mouseenter="handleDropdownEnter"
              @mouseleave="handleDropdownLeave"
            >
              <ProductMenu
                v-show="showKey === 2"
                @handleToDetail="handleDropdownLeave"
              />
              <SolutionMenu
                v-show="showKey === 3"
                @handleToDetail="handleDropdownLeave"
              />
              <DocumentMenu
                v-show="showKey === 4"
                @handleToDetail="handleDropdownLeave"
              />
              <SupportMenu
                v-show="showKey === 5"
                @handleToDetail="handleDropdownLeave"
              />
            </div>
          </BaseLayout>
        </b-collapse>
      </div>
    </div>

    <!-- 移动端菜单  -->
    <b-sidebar
      sidebar-class="sidebar-menu"
      v-model="openMenu"
      no-header
      width="100%"
    >
      <div class="tw-flex tw-w-full tw-h-full tw-bg-white tw-overflow-hidden">
        <div
          class="tw-flex tw-flex-col tw-w-32 tw-flex-none tw-bg-bgMain tw-text-sm tw-pt-4 tw-text-textMain"
        >
          <span
            v-for="item in leftMenuWithUser"
            :key="item.id"
            :class="{
              'menu-active': mobileMenuSelect?.path?.startsWith(item.path),
            }"
            class="tw-p-3 tw-cursor-pointer"
            @click="handleMobileMenu(item)"
            >{{ item.name }}</span
          >
        </div>
        <div
          class="tw-flex-1 tw-h-full tw-bg-white tw-flex-col tw-overflow-auto"
        >
          <div
            class="tw-flex tw-flex-col tw-px-4"
            v-if="!mobileMenuSelect.hasChild"
          >
            <span class="tw-text-base tw-text-textMain tw-font-bold tw-py-3">{{
              mobileMenuSelect.name
            }}</span>
            <span
              class="tw-text-sm tw-text-textLight tw-py-2"
              @click="handleClickRoute(mobileMenuSelect.path)"
            >
              {{ mobileMenuSelect.name }}
            </span>
          </div>
          <div class="tw-flex tw-flex-col" v-else>
            <MobileProductMenu
              v-if="mobileMenuSelect.id === 2"
              @handleToDetail="handleDropdownLeave"
            />
            <MobileSolutionMenu
              v-if="mobileMenuSelect.id === 3"
              @handleToDetail="handleDropdownLeave"
            />
            <MobileDocumentMenu
              v-if="mobileMenuSelect.id === 4"
              @handleToDetail="handleDropdownLeave"
            />
            <MobileSupportMenu
              v-if="mobileMenuSelect.id === 5"
              @handleToDetail="handleDropdownLeave"
            />
            <MobilePersonalMenu
              v-if="mobileMenuSelect.id === 10"
              @handleToDetail="handleDropdownLeave"
            />
          </div>
        </div>
      </div>
    </b-sidebar>
    <b-sidebar
      sidebar-class="sidebar-menu"
      v-model="openSearch"
      no-header
      width="100%"
    >
      <MobileSearch @onSearch="getEnter" @onCloseSearch="openSearch = false" />
    </b-sidebar>
  </div>
</template>
<script>
import { mapState } from "vuex";
import ProductList from "./ProductList.vue";
import ProductListSib from "./ProductListSib.vue";
import { indexApi, logoutApi, documentCategoriesApi } from "@/api/modules/home";
import BaseLayout from "../BaseLayout.vue";
import ProductMenu from "./ProductMenu.vue";
import SolutionMenu from "./SolutionMenu.vue";
import DocumentMenu from "./DocumentMenu.vue";
import SupportMenu from "./SupportMenu.vue";
import MobilePersonalMenu from "./MobilePersonalMenu.vue";
import TopSearch from "./TopSearch.vue";
import MobileSupportMenu from "./MobileSupportMenu.vue";
import MobileDocumentMenu from "./MobileDocumentMenu.vue";
import MobileSolutionMenu from "./MobileSolutionMenu.vue";
import MobileProductMenu from "./MobileProductMenu.vue";
import MobileSearch from "./MobileSearch.vue";
import UserInfo from "./UserInfo.vue";
import LanguageSwitcher from "@/components/LanguageSwitcher.vue";
import { goToOfficialWebsite } from "@/utils/domain";

export default {
  components: {
    ProductList,
    ProductListSib,
    BaseLayout,
    ProductMenu,
    SolutionMenu,
    DocumentMenu,
    SupportMenu,
    TopSearch,
    MobileSupportMenu,
    MobileDocumentMenu,
    MobileSolutionMenu,
    MobileProductMenu,
    MobilePersonalMenu,
    MobileSearch,
    UserInfo,
    LanguageSwitcher,
  },
  data() {
    return {
      // 是否滚动
      isShowTop: false,
      // 要搜索的值
      windowWidth: 0, // 存储当前窗口宽度的变量
      showKey: 0,
      userInfo: "",
      showCollapse: false,
      hoverTimer: null, // 添加定时器用于延迟隐藏
      openMenu: false,
      openSearch: false,
      mobileMenuSelect: {},
      lastScrollTop: 0,
      leftMenu: [
        // {
        //   id: 1,
        //   name: this.$t("RWA"),
        //   path: "/rwa",
        //   hasChild: false,
        // },
        {
          id: 1,
          name: this.$t("云服务"),
          path: "/cloud",
          hasChild: false,
        },
        {
          id: 2,
          name: this.$t("产品"),
          path: "/product",
          hasChild: true,
        },
        {
          id: 3,
          name: this.$t("解决方案"),
          path: "/solution",
          hasChild: true,
        },
        {
          id: 9,
          name: this.$t("案例库"),
          path: "/dapp-shop",
          hasChild: false,
        },
        {
          id: 4,
          name: this.$t("文档"),
          path: "/document",
          hasChild: true,
        },
        {
          id: 5,
          name: this.$t("支持与服务"),
          path: "/supportAndServices",
          hasChild: true,
        },
        {
          id: 6,
          name: this.$t("了解天晟"),
          path: "/company",
          hasChild: false,
        },
        {
          id: 7,
          name: this.$t("最新动态"),
          path: "/dynamics",
          hasChild: false,
        },
        {
          id: 8,
          name: this.$t("合作伙伴"),
          path: "/partner",
          hasChild: false,
        },
        // {
        //   id: 96,
        //   name: this.$t("Blockwatch"),
        //   path: "/product/96",
        //   hasChild: false,
        // },
        {
          id: 96,
          name: this.$t("Blockwatch"),
          path: "/BlockWatch",
          hasChild: false,
        },
      ],
    };
  },
  watch: {
    showCollapse: {
      handler(newVal) {
        const scrollbarWidth =
          window.innerWidth - document.documentElement.clientWidth;

        if (newVal) {
          // 阻止背景滚动但保持滚动条可见
          document.body.style.position = "fixed";
          document.body.style.overflowX = "hidden";
          document.body.style.overflowY = "scroll"; // 保持Y轴滚动条可见

          // 保持当前滚动位置
          document.body.style.top = `-${window.scrollY}px`;
          document.body.style.width = "100%";
        } else {
          // 菜单关闭时恢复滚动
          const scrollTop = Math.abs(parseInt(document.body.style.top || "0"));
          document.body.style.position = "";
          document.body.style.overflowX = "";
          document.body.style.overflowY = "";
          document.body.style.paddingRight = "";
          document.body.style.top = "";
          document.body.style.width = "";

          // 恢复滚动位置
          window.scrollTo(0, scrollTop);
        }
      },
    },
    openMenu(newVal) {
      if (newVal) {
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
        document.documentElement.style.overflow = "";
      }
    },
    openSearch(newVal) {
      if (newVal) {
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
        document.documentElement.style.overflow = "";
      }
    },
  },
  computed: {
    // 添加包含用户中心的菜单列表
    leftMenuWithUser() {
      // 复制原始菜单
      const menu = [...this.leftMenu];

      // 如果用户已登录，添加个人中心选项
      if (this.userInfo && this.userInfo.id !== null) {
        menu.push({
          id: 10,
          name: this.$t("个人中心"),
          path: "/controlCenter",
          hasChild: true,
        });
      }
      return menu;
    },
    current() {
      return this.$store.state.isType;
    },
    // 当前路由名称
    routName() {
      return this.$route.name;
    },
    ...mapState(["isSearch"]),
  },
  beforeDestroy() {
    // 搜索
    if (this.routName !== "search") {
      this.$store.commit("SET_ISSEARCH", "");
    }
  },
  created() {
    this.getIndex();
    this.getDocumentCategories();
    this.userInfo = localStorage.getItem("userInfo");
    this.userInfo = JSON.parse(this.userInfo);
  },
  mounted() {
    window.addEventListener("scroll", () => {
      // 当前滚动位置
      let currentScrollPosition = window.scrollY;
      if (currentScrollPosition > this.lastScrollTop) {
        this.isShowTop = true;
      } else if (currentScrollPosition < this.lastScrollTop) {
        this.isShowTop = false;
      }
      this.lastScrollTop = currentScrollPosition;
    });
  },
  methods: {
    // preventDefault(e) {
    //   e.preventDefault();
    // },
    handleLogoClick() {
      const currentPath = this.$route.path;

      if (currentPath.includes("/apiWord")) {
        // 如果当前在 /apiWord 相关路由下，跳转到二级域名网站
        goToOfficialWebsite("/");
      } else {
        // 否则跳转到首页
        this.$router.push("/");
      }
    },
    closeAllMenus() {
      this.showCollapse = false;
      this.openMenu = false;
      this.openSearch = false;
      this.showKey = 0;
    },
    handleClickSearch() {
      this.openSearch = !this.openSearch;
      if (this.openSearch) {
        this.openMenu = false;
      }
    },
    handleClickMenu() {
      this.openMenu = !this.openMenu;
      if (this.openMenu) {
        this.openSearch = false;
      }
      const path = this.$route.matched[0].path;
      if (!path) {
        this.mobileMenuSelect = this.leftMenu[0];
      } else {
        const menu = this.leftMenu.find((item) => item.path == path);
        this.mobileMenuSelect = menu || this.leftMenu[0];
      }
    },
    handleMouseEnter(key) {
      // 清除之前的定时器
      clearTimeout(this.hoverTimer);

      // 如果是不需要显示下拉菜单的项目，则隐藏下拉菜单
      if (
        key === 1 ||
        key === 6 ||
        key === 7 ||
        key === 96 ||
        key === 8 ||
        key === 9
      ) {
        // 延迟隐藏下拉菜单，避免快速移动鼠标时闪烁
        this.hoverTimer = setTimeout(() => {
          this.showCollapse = false;
          this.showKey = 0;
        }, 100);
        return;
      }

      // 对于需要显示下拉菜单的项目，设置显示
      this.hoverTimer = setTimeout(() => {
        this.showKey = key;
        this.showCollapse = true;
      }, 100);
    },

    // 新增：鼠标离开菜单项
    handleMouseLeave() {
      clearTimeout(this.hoverTimer);
    },

    // 新增：鼠标进入下拉菜单区域
    handleDropdownEnter() {
      clearTimeout(this.hoverTimer); // 清除隐藏定时器
    },

    // 新增：鼠标离开下拉菜单区域
    handleDropdownLeave() {
      this.showCollapse = false;
      this.showKey = 0;
      this.openMenu = false;
    },
    getIndex() {
      indexApi().then((res) => {
        this.$emit("indexInfo", res.data);
        this.$store.commit("SET_INDEXINFO", res.data);
        localStorage.setItem("indexInfo", JSON.stringify(res.data));
      });
    },
    // 获取文档类别
    getDocumentCategories() {
      documentCategoriesApi({
        pageIndex: 1,
        pageSize: 999,
      }).then((res) => {
        let children =
          res.data && res.data.list
            ? res.data.list.map((item1) => {
                return { route: "/document", ...item1 };
              })
            : [];
        // 将 id 为 6 的项移到数组最后
        const index = children.findIndex((item) => item.id === 6);
        if (index !== -1) {
          const item = children.splice(index, 1)[0];
          children.push(item);
        }
        localStorage.setItem("documentCategories", JSON.stringify(children));
      });
    },
    showUserDropdown() {
      // 关闭侧边栏菜单
      this.openMenu = false;
      // 显示用户下拉菜单
      this.$refs.dropdown2.show();
    },
    // 搜索框按回车触发
    getEnter(a) {
      this.$store.commit("SET_ISSEARCH", a);
      this.$router.push({
        name: "search",
        params: {
          name: a,
        },
      });
    },

    handleMobileMenu(item) {
      this.mobileMenuSelect = item;
    },

    // 页面跳转
    handleClickRoute(routeName, id) {
      // if (id === 96) {
      //   this.$router.push(`/product/${id}`);
      //   return;
      // }
      if (
        this.$route.path === routeName ||
        typeof routeName !== "string" ||
        !routeName.includes("/")
      )
        return;
      this.showKey = 0;
      this.$router.push(routeName);
      this.handleDropdownLeave();
    },

    // 退出
    async handleLoginOut() {
      try {
        await logoutApi();
      } catch (error) {
        console.warn("退出登录接口调用失败，已清理本地登录状态", error);
      } finally {
        localStorage.removeItem("userInfo");
        localStorage.removeItem("token");
        this.$store.commit("SET_LOGIN", false);
        this.$store.commit("SET_VERIFICATION", "0");

        const currentPath = this.$route.path;
        if (
          currentPath.includes("/pay") ||
          currentPath.includes("/payment") ||
          currentPath.includes("/order")
        ) {
          this.$router.push("/");
        } else {
          this.$router.go(0);
        }
        window.location.reload();
      }
    },
    handleClickAvatar() {
      this.$refs.dropdown.show();
    },
  },
};
</script>
<style scoped lang="scss">
// 固定在顶部
.top-menu {
  position: fixed;
  top: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  z-index: 100;
}

.imglogo {
  height: 36px;
  object-fit: contain;
}

.user-login {
  line-height: 38px;
  padding: 0 15px;
  color: #444;
  text-decoration: none;
  font-size: 14px;

  &:hover {
    cursor: pointer;
    // background: #2878ff;
    color: #000;
  }
}
.user-register {
  padding: 4px 15px;
  text-decoration: none;
  font-size: 14px;
}

.nav-action-icon-button {
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s;

  &:hover {
    opacity: 0.78;
  }
}

.nav-action-icon {
  display: block;
  width: 18px;
  height: 18px;
  object-fit: contain;
}

.mobile-header {
  height: 56px;
  padding: 0 16px;
  border-bottom: 1px solid rgba(226, 232, 240, 0.86);
  background: rgba(255, 255, 255, 0.97) !important;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.05);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.mobile-brand {
  display: inline-flex;
  width: 128px;
  min-width: 0;
  align-items: center;
}

.mobile-logo {
  display: block;
  width: 112px;
  max-width: 100%;
  height: auto;
  object-fit: contain;
}

.mobile-actions {
  display: flex;
  flex: none;
  align-items: center;
  gap: 10px;
}

.mobile-action-btn,
.mobile-menu-btn {
  width: 34px !important;
  height: 34px !important;
  box-sizing: border-box;
  flex: 0 0 34px;
  padding: 8px;
  border: 1px solid transparent;
  border-radius: 999px;
  background: transparent;
  color: #0f172a;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease;

  &:active {
    border-color: #d7e4ff;
    background: #edf4ff;
    color: #2563eb;
  }
}

.mobile-contact-btn {
  display: none !important;
}

.mobile-user-entry {
  display: inline-flex;
  flex: none;
  align-items: center;
}

.mobile-avatar {
  display: block;
  width: 32px;
  height: 32px;
  border: 2px solid #eef4ff;
  border-radius: 999px;
  box-shadow: 0 3px 10px rgba(64, 119, 248, 0.12);
  object-fit: cover;
}

.mobile-menu-btn {
  border-color: #dce8ff;
  background: #f5f8ff;
  padding: 9px 8px;
}

.menu-icon {
  align-items: center;
  justify-content: center;
  gap: 4px;

  .menu-line {
    display: block;
    width: 18px;
    height: 2px;
    border-radius: 999px;
    background: currentColor;
    transition: all 0.3s ease-in-out;
    transform-origin: center;
  }
}

.menu-icon.open {
  .menu-line:nth-child(1) {
    transform: translateY(6px) rotate(45deg);
  }

  .menu-line:nth-child(2) {
    opacity: 0;
    transform: scale(0);
  }

  .menu-line:nth-child(3) {
    transform: translateY(-6px) rotate(-45deg);
  }
}

::v-deep .b-sidebar {
  top: 64px;
}

::v-deep .sidebar-menu {
  background-color: #fff !important;
}
::v-deep .dropdown-menu {
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.05);
  border: none;
}

.menu-active {
  position: relative;
  @apply tw-text-primary tw-bg-white;
}

.menu-active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 2px;
  height: 100%;
  background-color: #4077f8;
}

.backdrop-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 99;
  pointer-events: auto;
}

.backdrop-fade-enter-active,
.backdrop-fade-leave-active {
  transition: opacity 0.3s ease;
}

.backdrop-fade-enter,
.backdrop-fade-leave-to {
  opacity: 0;
}

.no-scroll {
  position: fixed;
  overflow-x: hidden;
  overflow-y: scroll;
  width: 100%;
}
.dropdown-content {
  overflow-y: auto;
  max-height: 80vh;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
}
@media screen and (max-width: 768px) {
  .header-menu {
    height: 56px !important;
  }

  ::v-deep .b-sidebar {
    top: 56px;
  }

  .user-register {
    padding: 2px 8px;
  }
}
</style>
